<template>
  <layout-block :has-border="false" :width="width" margin="48px 16px">
    <layout-block-head
      icon="https://gatoreviews.s3.eu-west-3.amazonaws.com/common/emails/new/megaphone.png"
      :title="audience.title"
      padding-top="8px"
      padding-bottom="0"
    />
    <div
      v-for="(a, idx) in audience.data"
      :key="`audience-section-${idx}`"
      style=" margin: 0 -2px; width: calc(100% + 4px);"
    >
      <div
        style="

                  display: inline-block;
                  margin-top: 16px ;
                  border-radius: 25px;
                  background-color: #EAEEF7;
                  padding: 8px 16px;
                  color:#06152F;
                  font-size: 18px;
                "
      >
        {{ a.title }}
      </div>
      <layout-block-section margin="32px 0 16px">
        <table width="100%" style="border-collapse: collapse;">
          <tr>
            <td
              align="center"
              v-for="(d, j) in a.data"
              style=" color: #06152F;font-size: 14px;"
              :key="`audience-data-${idx}-${j}`"
              :style="{
                borderLeft: '2px solid #E5E8EE',
                borderRight: '2px solid #E5E8EE',
                width: `${100 / a.data.length}%`,
                padding: '8px 16px',
              }"
            >
              <span style="font-size: 20px; font-weight:500;">
                {{ d.name }}
              </span>
            </td>
          </tr>
          <tr>
            <td
              align="center"
              v-for="(d, k) in a.data"
              :key="`audience-data-${idx}-${k}`"
              :style="{
                borderLeft: '2px solid #E5E8EE',
                borderRight: '2px solid #E5E8EE',
                padding: '8px 16px 16px',
                width: `${100 / a.data.length}%`,
              }"
            >
              <span
                style="

                      display: inline-block;
                      margin: 0;
                      vertical-align: middle;
                      color:#06152F;
                      font-size: 42px;
                      font-weight: bold;
                    "
              >
                {{ d.value }}
              </span>
              <ui-trend style="vertical-align: middle;" :trend="d.trend" v-if="d.trend" />
            </td>
          </tr>
        </table>
      </layout-block-section>
    </div>
  </layout-block>
</template>

<script>
import LayoutBlock from '@/components/Layout/Block.vue'
import LayoutBlockHead from '@/components/Layout/Block/Head.vue'
import LayoutBlockSection from '@/components/Layout/Block/Section.vue'
import UiTrend from '@/components/UI/Trend.vue'

export default {
  name: 'ReportAudience',
  components: {
    LayoutBlock,
    LayoutBlockHead,
    LayoutBlockSection,
    UiTrend,
  },
  props: {
    audience: {
      type: Object,
      required: true,
    },
    width: {
      type: String,
      default: 'auto',
    },
  },
}
</script>
